const clients = [
  { name: "KTC", note: "Travel & Hospitality", logo: "/brand/clients/ktc.png" },
  { name: "Carzonrent", note: "Mobility", logo: "/brand/clients/carzonrent.svg" },
  { name: "Carclub", note: "Mobility", logo: "/brand/clients/carclub.png" },
  { name: "Network18 Media", note: "Media · Broadcast", logo: "/brand/clients/network18.png" },
  { name: "Experion Technologies", note: "IT Services", logo: "/brand/clients/experion.png" },
  { name: "Tata Elxsi Limited", note: "Engineering · Design", logo: "/brand/clients/tataelxsi.png" },
  { name: "Autoriders International", note: "Mobility", logo: "/brand/clients/autoriders.png" },
  { name: "Formula Corporate Services", note: "Corporate Services" },
  { name: "Varahe Analytics", note: "Data Analytics" },
  { name: "CNN", note: "Global Media", logo: "/brand/clients/cnn.png" },
  { name: "Caidya", note: "Clinical Research", logo: "/brand/clients/caidya.png" },
  { name: "Flytxt", note: "AI · Analytics", logo: "/brand/clients/flytxt.png" },
];

export default function Clients() {
  return (
    <section className="section-pad bg-white" data-testid="clients-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-12 reveal">
          <div className="eyebrow mb-4">Our Clients</div>
          <h2 className="headline text-[34px] md:text-[44px]" data-testid="clients-headline">
            Trusted by leading brands across India.
          </h2>
          <p className="mt-5 text-slate-600 text-[16px] leading-relaxed">
            From global media networks to fast-scaling tech and analytics firms, Rydey
            powers the daily commute and executive travel for some of the most respected
            corporate names operating in Kerala and beyond.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-0 border border-slate-200 rounded-2xl overflow-hidden bg-white">
          {clients.map((c, i) => (
            <ClientCell key={c.name} {...c} index={i} total={clients.length} />
          ))}
        </div>

        <p className="mt-8 text-[12.5px] text-slate-500 reveal">
          Featured client list per Rydey corporate profile · Logos and names used with
          permission. Trademarks belong to their respective owners.
        </p>
      </div>
    </section>
  );
}

function ClientCell({ name, note, logo, index, total }) {
  const colsLg = 4;
  const isLastColLg = (index + 1) % colsLg === 0;
  const lastRowStartLg = total - (total % colsLg || colsLg);
  const isLastRowLg = index >= lastRowStartLg;

  return (
    <div
      data-testid={`client-cell-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className={`group relative p-7 md:p-8 flex flex-col justify-center items-center text-center min-h-[160px] bg-white hover:bg-[#f8f9fc] transition-all duration-300 reveal ${
        !isLastColLg ? "lg:border-r" : ""
      } ${(index % 3 !== 2) ? "sm:border-r" : "sm:border-r-0"} ${
        index % 2 === 0 ? "border-r" : "border-r-0"
      } border-slate-200 ${!isLastRowLg ? "lg:border-b" : ""} border-b sm:border-b`}
      style={{ transitionDelay: `${(index % 4) * 0.04}s` }}
    >
      {logo ? (
        <>
          <div className="flex-1 flex items-center justify-center w-full mb-2.5 min-h-[64px]">
            <img
              src={logo}
              alt={`${name} logo`}
              className="max-h-12 md:max-h-14 max-w-[80%] object-contain transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
              data-testid={`client-logo-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            />
          </div>
          <div className="text-[10.5px] tracking-[0.16em] uppercase font-semibold text-slate-500 group-hover:text-[#F5A623] transition-colors">
            {note}
          </div>
        </>
      ) : (
        <>
          <div className="flex-1 flex items-center justify-center w-full mb-2.5 min-h-[64px]">
            <div className="font-extrabold tracking-tight text-[19px] md:text-[20px] text-[#0D1B40] group-hover:text-[#F5A623] transition-colors leading-tight">
              {name}
            </div>
          </div>
          <div className="text-[10.5px] tracking-[0.16em] uppercase font-semibold text-slate-400 group-hover:text-[#F5A623] transition-colors">
            {note}
          </div>
        </>
      )}
    </div>
  );
}
